import { Alert, Heading, VFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Box } from 'components/Box'
import { Breadcrumb } from 'components/breadcrumb'
import { PageLoading } from 'components/loading'
import { startOfDay } from 'date-fns'
import { css } from 'emotion'
import { StatusCuidadoCompartilhadoEnum } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'
import React from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { usePeriodoGestacional } from 'view/atendimentos/detail/soap/aside/pre-natal/hooks/usePeriodoGestacional'

import { CuidadoCompartilhadoHeaderTabs } from '../components/CuidadoCompartilhadoHeaderTabs'
import { DiscussaoCasoPageContent } from '../components/DiscussaoCasoPageContent'
import { CuidadoCompartilhadoEvolucoes } from '../cuidado-compartilhado/components/cuidado-compartilhado-evolucoes/CuidadoCompartilhadoEvolucoes'
import { CuidadoCompartilhadoPanel } from '../cuidado-compartilhado/components/CuidadoCompartilhadoPanel'
import { CheckObitoModalCuidadoCompartilhado } from '../cuidado-compartilhado/discussao-caso/CheckObitoModalCuidadoCompartilhado'
import { CidadaoCuidadoCompartilhado, CuidadoCompartilhadoModel } from '../model-cuidadoCompartilhado'

interface VisualizarCuidadoCompartilhadoViewProps {
  cuidadoCompartilhado: CuidadoCompartilhadoModel
}

export const VisualizarCuidadoCompartilhadoView = (props: VisualizarCuidadoCompartilhadoViewProps) => {
  const { cuidadoCompartilhado } = props

  const { getServerTimeNow } = useServerTime()
  const { acesso } = useAcessoLotacaoOrEstagio()

  const prontuario = cuidadoCompartilhado.cidadao.prontuario
  const dataAtendimento = Number(startOfDay(getServerTimeNow()))
  const preNatalAtivo = prontuario?.preNatalAtivo
  const ultimaDumPreNatalAtivo = preNatalAtivo?.ultimaDum
  const isStatusAguardando = cuidadoCompartilhado.status === StatusCuidadoCompartilhadoEnum.AGUARDANDO
  const isCidadaoObito = cuidadoCompartilhado.cidadao.faleceu
  const isProfissionalExecutante = cuidadoCompartilhado.lotacaoExecutanteAtual?.id === acesso.id
  const isCompartilhadoComUnidade =
    isUndefinedOrNull(cuidadoCompartilhado.lotacaoExecutanteAtual) &&
    cuidadoCompartilhado.unidadeSaudeExecutanteAtual.id === acesso.unidadeSaude.id
  const showAlertObito = isStatusAguardando && isCidadaoObito && (isProfissionalExecutante || isCompartilhadoComUnidade)

  const { loading: loadingDataPeriodoGestacional, idadeGestacional } = usePeriodoGestacional({
    prontuarioId: prontuario.id,
    dum: ultimaDumPreNatalAtivo,
    dataAtendimento,
  })

  if (loadingDataPeriodoGestacional) {
    return <PageLoading message='Carregando dados do cuidado compartilhado...' />
  }

  const renderDiscussaoCaso = (cidadao: CidadaoCuidadoCompartilhado, headerRef: React.RefObject<HTMLDivElement>) => (
    <DiscussaoCasoPageContent
      cidadao={cidadao}
      headerRef={headerRef}
      idadeGestacional={idadeGestacional}
      cuidadoCompartilhadoId={cuidadoCompartilhado.id}
      isDiscutirCaso={false}
    >
      <CheckObitoModalCuidadoCompartilhado showModalObito={showAlertObito}>
        <VFlow>
          {showAlertObito && (
            <Alert type='warning' style={{ padding: '0.5rem', inlineSize: '-webkit-fill-available' }} inline>
              <strong>Cidadão veio a óbito, reconduza o cuidado para finalizá-lo.</strong>
              <br />
              Este cuidado compartilhado será finalizado automaticamente quando o cuidado for reconduzido ao
              solicitante.
            </Alert>
          )}
          <CuidadoCompartilhadoPanel cuidadoCompartilhado={cuidadoCompartilhado} />

          <VFlow vSpacing={0.5}>
            <Heading level={3}>Discussão</Heading>

            <Box
              style={css`
                padding: 1rem 0;
              `}
            >
              <CuidadoCompartilhadoEvolucoes cuidadoCompartilhadoId={cuidadoCompartilhado.id} />
            </Box>
          </VFlow>
        </VFlow>
      </CheckObitoModalCuidadoCompartilhado>
    </DiscussaoCasoPageContent>
  )

  return (
    <>
      <Breadcrumb title='Visualizar discussão' />
      <CuidadoCompartilhadoHeaderTabs
        cuidadoCompartilhado={cuidadoCompartilhado}
        renderDiscussaoCaso={renderDiscussaoCaso}
        isVisualizacao={true}
        idadeGestacional={idadeGestacional}
      />
    </>
  )
}
